export const formStyles = {
  width: { xs: '100%', md: 'calc(50% - 8px)' },
};